import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F3F6FB',
    border: '1px solid #E2E7F0',
    borderRadius: '12px',
    padding: '12px 16px',
    color: '#1A1A1A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontSize: '0.95rem',
    fontWeight: 600,
    lineHeight: 1.35,
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '10px 12px',
      fontSize: '0.88rem',
    },
  },
  icon: {
    width: '18px',
    height: '18px',
    flexShrink: 0,
    opacity: 0.9,
  },
}));

export default function InfoMessage(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img
        src="https://d2zdlj1ifv8u1d.cloudfront.net/images/info.svg"
        className={classes.icon}
      />
      {props.children}
    </div>
  );
};
